import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";
import AppButton from "components/app-button";
import PropTypes from "prop-types";
import serveRequestErrors from "common/serve-request-errors";
import api from "services/api";


const ConfirmModal = forwardRef((props, ref) => {
	const [visible, setVisible] = useState(false);
	const [appointmentId, setappointmentId] = useState(null);
	const [status, setStatus] = useState(null);

	useImperativeHandle(ref, () => ({
		onHandleDismiss,
		onHandleShow: (id, statusValue) => {
			setappointmentId(id);
			setStatus(statusValue);
			setVisible(true);
		}
	}));


	const onHandleDismiss = useCallback(() => {
		setVisible(false);
		setStatus(null);
		setappointmentId(null);
	}, []);

	const handleConfirm = async () => {
		let payload = {
			"status": status,
			"appointmentId": appointmentId,
		};

		try {
			const response = await api.post.appointment.updateStatus(payload);
			if (props.onHandleGetList) props.onHandleGetList();
			setVisible(false);
		} catch (error) {
			serveRequestErrors(error);
		}

		setVisible(false);
	};

	return (
		<Modal classes={{ root: "app-position-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="position-modal" aria-describedby="position-modal">
			<div className="position-modal">
				<div className="position-modal__main">
					<div className="position-modal__header">
						<p className="position-modal__title">Confirmation</p>
					</div>

					<form className="position-modal__body" >
						<p>
							Are you sure you wish to update the appointment status to {status} ?
						</p>
						<div className="position-modal__button-container">
							<AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} />
							<AppButton type="button" label="Update" onClick={handleConfirm} />
						</div>
					</form>
				</div>
			</div>
		</Modal>
	);
});

ConfirmModal.propTypes = {
};

export default memo(ConfirmModal);
